'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint-disable */
var ArrowVertical = function ArrowVertical(props) {
  return _react2.default.createElement(
    _Icon2.default,
    _extends({ viewBox: '0 0 7 9' }, props),
    _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement(
        'title',
        null,
        '7762852E-35A4-40FC-BA75-3D07C1D10D08'
      ),
      _react2.default.createElement('path', { d: 'M3.5 0L0 3.375.5 4 3 1.499V9l.999-2V1.499L6.5 4l.5-.625z', fill: 'currentColor', fillRule: 'evenodd' })
    )
  );
};
/*eslint-enable */

exports.default = ArrowVertical;
//# sourceMappingURL=ArrowVertical.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/src/Icons/dist/components/ArrowVertical.js